var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      on: {
        touchstart: _vm.touchAction,
        touchmove: _vm.touchAction,
        touchend: _vm.touchAction
      }
    },
    [
      _c(
        "div",
        { staticClass: "heading d-block d-sm-none d-md-block" },
        [
          _c("level-choose", {
            staticClass: "level-choose",
            attrs: {
              dialogTag: "normal",
              value: _vm.currentLevel,
              chooseList: _vm.chooseList
            },
            on: { input: _vm.changeLevel }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "score" },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.$t("score")) + "\n            "
              ),
              _c("tween-number", {
                attrs: { number: _vm.score, duration: 200 }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "step" },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.$t("step")) + "\n            "
              ),
              _c("tween-number", {
                style: { color: _vm.step < 10 ? "red" : "white" },
                attrs: { number: _vm.step, duration: 200 }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "challenge-stat" },
            _vm._l(_vm.challengeStatList, function(challengeStat) {
              return _c(
                "li",
                {
                  key: challengeStat.key,
                  style: {
                    backgroundColor: challengeStat.done ? "#BBD08F" : ""
                  }
                },
                [
                  challengeStat.type === "number"
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "challenge-number" },
                          [
                            _c("number", {
                              attrs: {
                                number: challengeStat.data.number,
                                "view-width": _vm.viewWidth,
                                action: "static"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "challenge-hit" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(challengeStat.data.hit) +
                              "/" +
                              _vm._s(challengeStat.data.total) +
                              "\n                    "
                          )
                        ])
                      ])
                    : challengeStat.type === "score"
                    ? _c("div", [
                        _c("div", { staticClass: "challenge-score" }, [
                          _vm._v(
                            "\n                        S\n                    "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "challenge-score-score" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(challengeStat.data.score) +
                              "\n                    "
                          )
                        ])
                      ])
                    : _vm._e()
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "new-game-btn",
              attrs: { title: "new game" },
              on: { click: _vm.newGame }
            },
            [_vm._v("\n            ⟳\n        ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row  no-gutters" }, [
        _c("div", { staticClass: "col-0 col-sm-0 col-md-3 col-lg-3 col-xl" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-sm-8 col-md-6 col-lg-6 col-xl game" },
          [
            _vm.gameOver
              ? _c("div", { staticClass: "game-over" }, [
                  _vm._v("\n                " + _vm._s(_vm.$t("over"))),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "a",
                    { staticClass: "restart", on: { click: _vm.newGame } },
                    [_vm._v(_vm._s(_vm.$t("again")))]
                  )
                ])
              : _vm.gameWin
              ? _c("div", { staticClass: "game-win" }, [
                  _vm._v("\n                " + _vm._s(_vm.$t("win"))),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "next-challenge",
                      on: { click: _vm.nextChallenge }
                    },
                    [_vm._v(_vm._s(_vm.$t("next")))]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.rowCol, function(row) {
              return _c(
                "div",
                { staticClass: "row  no-gutters" },
                _vm._l(row, function(rc) {
                  return _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("number", {
                        ref: "number",
                        refInFor: true,
                        attrs: {
                          number: _vm.numbers[rc.row][rc.col],
                          "view-width": _vm.viewWidth,
                          action: _vm.actions[rc.row][rc.col],
                          duration: _vm.duration
                        }
                      })
                    ],
                    1
                  )
                }),
                0
              )
            }),
            _vm._v(" "),
            _c("rate-feedback", {
              staticClass: "d-block d-sm-none d-md-block",
              attrs: { id: "rate-feedback", dialogTag: "normal" }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-block d-sm-none d-md-block challenge-mode-navigate"
              },
              [
                _c(
                  "div",
                  {
                    attrs: {
                      "data-toggle": "tooltip",
                      "data-placement": "bottom",
                      trigger: "manual",
                      title: _vm.$t("mode")
                    },
                    on: {
                      mouseover: _vm.classicModeNavMouseOver,
                      mouseout: _vm.classicModeNavMouseOut,
                      click: _vm.classicModeNavMouseClick
                    }
                  },
                  [_vm._v("\n                    ➨\n                ")]
                ),
                _vm._v(" "),
                _c("radio-toggle", {
                  staticClass: "radio-toggle",
                  model: {
                    value: _vm.radioStat,
                    callback: function($$v) {
                      _vm.radioStat = $$v
                    },
                    expression: "radioStat"
                  }
                })
              ],
              1
            )
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-0 col-sm-4 col-md-3 col-lg-3 col-xl" }, [
          _c("div", { staticClass: "heading-sm d-none d-sm-block d-md-none" }, [
            _c(
              "div",
              { staticClass: "level-choose-sm-area" },
              [
                _c("level-choose", {
                  staticClass: "level-choose-sm",
                  attrs: {
                    dialogTag: "small",
                    value: _vm.currentLevel,
                    chooseList: _vm.chooseList
                  },
                  on: { input: _vm.changeLevel }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", [
              _c(
                "div",
                { staticClass: "score-sm" },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("score")) +
                      "\n                        "
                  ),
                  _c("tween-number", {
                    attrs: { number: _vm.score, duration: 200 }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "step-sm" },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("step")) +
                      "\n                        "
                  ),
                  _c("tween-number", {
                    style: { color: _vm.step < 10 ? "red" : "white" },
                    attrs: { number: _vm.step, duration: 200 }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "challenge-stat-sm" },
              _vm._l(_vm.challengeStatList, function(challengeStat) {
                return _c(
                  "li",
                  {
                    key: challengeStat.key,
                    style: {
                      backgroundColor: challengeStat.done ? "#BBD08F" : ""
                    }
                  },
                  [
                    challengeStat.type === "number"
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "challenge-number-sm" },
                            [
                              _c("number", {
                                attrs: {
                                  number: challengeStat.data.number,
                                  "view-width": _vm.viewWidth,
                                  action: "static"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "challenge-hit-sm" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(challengeStat.data.hit) +
                                "/" +
                                _vm._s(challengeStat.data.total) +
                                "\n                            "
                            )
                          ])
                        ])
                      : challengeStat.type === "score"
                      ? _c("div", [
                          _c("div", { staticClass: "challenge-score-sm" }, [
                            _vm._v(
                              "\n                                S\n                            "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "challenge-score-score-sm" },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(challengeStat.data.score) +
                                  "\n                            "
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "new-game-btn-sm-area" }, [
              _c(
                "a",
                {
                  staticClass: "new-game-btn-sm",
                  attrs: { title: "new game" },
                  on: { click: _vm.newGame }
                },
                [_vm._v("\n                        ⟳\n                    ")]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tip-sm d-none d-sm-block d-md-none" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("left")) +
                " ← ↑ → ↓ " +
                _vm._s(_vm.$t("right")) +
                "\n            "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-none d-sm-block d-md-none",
              attrs: { id: "last-line-sm" }
            },
            [
              _c(
                "div",
                { attrs: { id: "last-line-container-sm" } },
                [
                  _c("rate-feedback", {
                    attrs: { id: "rate-feedback-sm", dialogTag: "small" }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "challenge-mode-navigate-sm" },
                    [
                      _c(
                        "div",
                        {
                          attrs: {
                            "data-toggle": "tooltip",
                            "data-placement": "bottom",
                            trigger: "manual",
                            title: _vm.$t("mode")
                          },
                          on: {
                            mouseover: _vm.classicModeNavMouseOverSM,
                            mouseout: _vm.classicModeNavMouseOutSM,
                            click: _vm.classicModeNavMouseClickSM
                          }
                        },
                        [
                          _vm._v(
                            "\n                            ➨\n                        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("radio-toggle", {
                        staticClass: "radio-toggle-sm",
                        model: {
                          value: _vm.radioStat,
                          callback: function($$v) {
                            _vm.radioStat = $$v
                          },
                          expression: "radioStat"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tip d-block d-sm-none d-md-block" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$t("left")) +
            " ← ↑ → ↓ " +
            _vm._s(_vm.$t("right")) +
            "\n    "
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }